import { bus } from "@/main";

export default {
	name: "App",
	data() {
		return {
			menuIsOpen: false,
			isLoading: true,
		}
	},
	watch: {
		// "$route": function() {process.env.NODE_ENV === "development" ? console.log(this.$route) : null}
		"$route": function() {
			this.menuIsOpen = false;
			this.isLoading = true;
		}
	},
	created() {
		bus.$on("evalColors", () => {
			this.isLoading = false;
		});
		bus.$on("toggleMenu", (value) => {
			if( value == false)
				this.menuIsOpen = false
			else
				this.menuIsOpen = !this.menuIsOpen
		});
		bus.$on("PAGE_IS_READY", (isReady) => {
			document.documentElement.toggleAttribute("data-page-is-ready", isReady);
		});
	},
	methods: {}
}



// WEBPACK FOOTER //
// ./src/App.js